import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class Login {
  constructor(form) {
    this.form = form;
    this.showButton = form.querySelector(s.selectors$F.showReset);
    this.hideButton = form.querySelector(s.selectors$F.hideReset);
    this.recover = form.querySelector(s.selectors$F.recover);
    this.login = form.querySelector(s.selectors$F.login);
    this.success = form.querySelector(s.selectors$F.recoverSuccess);
    this.successText = form.querySelector(s.selectors$F.recoverSuccessText);
    this.init();
  }

  init() {
    if (window.location.hash == s.selectors$F.recoverHash) {
      this.showRecoverPasswordForm();
    } else {
      this.hideRecoverPasswordForm();
    }

    if (this.success) {
      this.successText.classList.remove(c.classes$v.hidden);
    }

    this.showButton.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        this.showRecoverPasswordForm();
      },
      false
    );
    this.hideButton.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        this.hideRecoverPasswordForm();
      },
      false
    );
  }

  showRecoverPasswordForm() {
    this.recover.classList.remove(c.classes$v.hidden);
    this.login.classList.add(c.classes$v.hidden);
    window.location.hash = s.selectors$F.recoverHash;
    return false;
  }

  hideRecoverPasswordForm() {
    this.login.classList.remove(c.classes$v.hidden);
    this.recover.classList.add(c.classes$v.hidden);
    window.location.hash = '';
    return false;
  }
}